import { IconType } from "./icons.types";

export const RefreshIcon = ({ className, color = "#28303F" }: IconType) => {
  return (
    <svg
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.59 0.299143C11.9771 0.151612 12.4104 0.345781 12.558 0.732831L13.7361 3.82359C13.8494 4.12092 13.7628 4.45739 13.52 4.66304C13.2771 4.86868 12.931 4.89873 12.6564 4.738C11.5836 4.11008 10.335 3.74996 9 3.74996C4.99594 3.74996 1.75 6.99589 1.75 11C1.75 12.3217 2.10304 13.5588 2.71946 14.6244C2.92687 14.983 2.80435 15.4418 2.4458 15.6492C2.08726 15.8566 1.62846 15.734 1.42105 15.3755C0.676117 14.0877 0.25 12.5925 0.25 11C0.25 6.16747 4.16751 2.24996 9 2.24996C9.9386 2.24996 10.8434 2.39798 11.6918 2.67204L11.1563 1.26709C11.0088 0.880036 11.203 0.446673 11.59 0.299143ZM15.5542 6.35075C15.9127 6.14335 16.3715 6.26587 16.5789 6.62441C17.3239 7.91219 17.75 9.40745 17.75 11C17.75 15.8324 13.8325 19.75 9 19.75C8.0614 19.75 7.15659 19.6019 6.30814 19.3279L6.84367 20.7328C6.9912 21.1199 6.79704 21.5532 6.40999 21.7008C6.02294 21.8483 5.58958 21.6541 5.44204 21.2671L4.26392 18.1763C4.15058 17.879 4.2372 17.5425 4.48001 17.3369C4.72282 17.1312 5.06897 17.1012 5.34358 17.2619C6.41641 17.8898 7.66501 18.25 9 18.25C13.0041 18.25 16.25 15.004 16.25 11C16.25 9.67817 15.897 8.44112 15.2805 7.3755C15.0731 7.01696 15.1957 6.55816 15.5542 6.35075Z"
        fill={color}
      />
    </svg>
  );
};
